module.exports = __webpack_public_path__ + "img/japan-congenital-and-perinatal-diseases-male.b7a8365a.png";